import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { createAuthConfig } from './app/authentication/auth-config';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';


(async () => {
  const authConfig = await createAuthConfig();

  if (environment.production) {
    enableProdMode();
  }

  platformBrowserDynamic([
    { provide: 'AUTH_CONFIG', useValue: authConfig }
  ])
    .bootstrapModule(AppModule)
    .catch(err => console.error(err));
})();
